import { all, fork } from 'redux-saga/effects';
import flagsSaga from './flags.saga';

export function* rootSaga() {
  yield all([fork(flagsSaga)]);
}
